// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Grid, Typography, } from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import BoxImage from '../Common/BoxImage';
import BoxSubPage from '../Common/BoxSubPage';
import StackImage from '../Common/StackImage';
import DialogImage from '../Common/DialogImage';
import { ContentTitle } from '../Common/TypographyTYH';

//import Image from './Image.jpg';

const VAWork = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component VAWork Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const F1WorksCount = 30;
    const F2WorksCount = 35;
    const F3WorksCount = 25;

    const F6Works = [
        { Filename: 'SF_01_F6_霍俊銘.jpg', Title: '《人類的禍害》F.6 霍俊銘', },
        { Filename: 'SF_02_F6_袁詠琴.jpg', Title: '《當代學生的速食文化》F.6 袁詠琴' },
        { Filename: 'SF_03_F6_施芯恬.jpg', Title: '《色彩繽紛的霓虹世界》F.6 施芯恬' },
        { Filename: 'SF_04_F6_李晃希.jpg', Title: '《經濟實惠的早餐》F.6 李晃希' },
        { Filename: 'SF_05_F6_顏棠瑤.jpg', Title: '《美味拼圖》F.6 顏棠瑤' },
        { Filename: 'SF_06_F6_李詩晴.jpg', Title: '《羅密歐與朱麗葉》F.6 李詩晴' },
        { Filename: 'SF_07_F6_吳穎芝.jpg', Title: '《活在壓力下的香港學生》F.6 吳穎芝' },
        { Filename: 'SF_08_F6_吳穎芝.jpg', Title: '《救贖》F.6 吳穎芝' },
        { Filename: 'SF_09_F6_吳穎芝.jpg', Title: '《上岸》F.6 吳穎芝' },
        { Filename: 'SF_10_F6_胡凱婷.jpg', Title: '《石板街》F.6 胡凱婷' },
        { Filename: 'SF_11_F6_李承晉.jpg', Title: '《夜空中的招牌》F.6 李承晉' },
        { Filename: 'SF_12_F6_施芯恬.jpg', Title: '《校園中的一抹光》F.6 施芯恬' },
        { Filename: 'SF_13_F6_麥詠琳.jpg', Title: '《畸形的美》F.6 麥詠琳' },
        { Filename: 'SF_14_F6_麥詠琳.jpg', Title: '《真實的我？》F.6 麥詠琳' },
        { Filename: 'SF_15_F6_吳詠兒.jpg', Title: '《夕陽下的旅程》F.6 吳詠兒' },
        { Filename: 'SF_16_F6_吳詠兒.jpg', Title: '《變遷的商店》F.6 吳詠兒' },
        { Filename: 'SF_17_F6_曾穎心.jpg', Title: '《和平女神的悲傷》F.6 曾穎心' },
        { Filename: 'SF_18_F6_曾穎心.jpg', Title: '《天使的墜落》F.6 曾穎心' },
    ];

    const [src, setSrc] = React.useState(null);

    // TODO: Define event
    const handleDialogClosed = () => { setSrc(null) }

    React.useEffect(() => { window.scrollTo(0, 0); }, []);

    // TODO: Return component
    const RenderStackImageJunior = ({ form, work }) => (
        <StackImage onClick={() => { setSrc(`https://www.pohtyh.edu.hk/Files/VAWork/${form}_${(work).toString().padStart(2, '0')}.jpg`) }} hover={true}>
            <BoxImage src={`https://www.pohtyh.edu.hk/Files/VAWork/${form}_${(work).toString().padStart(2, '0')}.jpg`} />
        </StackImage>
    );

    const RenderStackImageSenior = ({ work }) => (
        <StackImage onClick={() => { setSrc(`https://www.pohtyh.edu.hk/Files/VAWork/${work.Filename}`) }} hover={true}>
            <BoxImage src={`https://www.pohtyh.edu.hk/Files/VAWork/${work.Filename}`} />
            <Typography sx={{ alignItems: 'center', color: 'white', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                {work.Title}
            </Typography>
        </StackImage>
    );

    const RenderBoxJunior = ({ form, count }) => (
        <Box>
            <ContentTitle text={Text.VAWork.Subtitle[form][context.language]} />
            <Grid container spacing={2} sx={{ mb: 2 }}>
                {Array.from({ length: count }, (_, i) => (
                    <Grid size={{ xs: 6, md: 4 }}>
                        <RenderStackImageJunior key={i} form={form} work={i + 1} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );

    const RenderBoxSenior = () => (
        <Box>
            <ContentTitle text={Text.VAWork.Subtitle.F6[context.language]} />
            <Grid container spacing={2} sx={{ mb: 2 }}>
                {F6Works.map(work =>
                    <Grid size={{ xs: 6, md: 4 }}>
                        <RenderStackImageSenior work={work} />
                    </Grid>
                )}
            </Grid>
        </Box>
    );

    return (
        <BoxSubPage
            disableMenu={true}
            disableSubtitle={true}
            id="VAWork"
            title={Text.VAWork.Title[context.language]}
        >
            <RenderBoxJunior form={'F1'} count={F1WorksCount} />
            <RenderBoxJunior form={'F2'} count={F2WorksCount} />
            <RenderBoxJunior form={'F3'} count={F3WorksCount} />
            <RenderBoxSenior />
            {src && <DialogImage src={src} onClose={handleDialogClosed} />}
        </BoxSubPage>
    );
};
export default VAWork;